import { Text } from '@mantine/core'

export function SectionHeader({ children }) {
  return (
    <Text size="sm" fw={700} ff="Orbitron, sans-serif" c="cyan.4" mb="sm">
      {children}
    </Text>
  )
}
